import { useState, useEffect } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import 'aos/dist/aos.css';
import AOS from 'aos';
import Loader from '../Animations/Loader';
import AddSettingForm from "../Setting/AccountDetail";
import AgreementForm from "../Setting/Agreement";
import TeamMemberForm from "../Setting/TeamMembers";
import TaxInfoForm from "../Setting/TaxInfo";
import ApiKeyForm from "../Setting/ApiKey";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth

const Setting = () => {
  const [loading, setLoading] = useState(true);
  const { authState } = useAuth(); // Get authState from AuthContext
  const role = authState.roles;
  const admin = role === "Admin";
  
  const [activeSection, setActiveSection] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    phoneNo: '',
    skypeId: '',
    changePassword: false,
  });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSaveChanges = () => {
    setActiveSection('');
  };

  const toggleSection = (sectionName) => {
    if (activeSection !== sectionName) {
      setActiveSection(sectionName);
    }
  };
  

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="flex bg-gray-100 min-h-screen">
      {/* Sidebar */}
      {admin ? <AdminSidebar /> : <Sidebar />}

      {/* Main Content */}
      <div className="flex-1 bg-gray-100">

        <div className="flex-1 flex flex-col">
          <Topbar />

          <div className="top-20 z-10 bg-white py-4 w-full px-4 mt-20">
            <div className="flex flex-wrap md:flex-nowrap space-x-2 mb-6">
              {/* Tabs */}
              {['form', 'agreement', 'team', 'taxInfo', 'apiKey'].map((section) => (
                <div
                  key={section}
                  onClick={() => toggleSection(section)}
                  className={`cursor-pointer mb-2 md:mb-0 md:px-4 py-2 w-full md:w-auto rounded transition duration-300 ease-in-out shadow-lg 
                  ${activeSection === section ? 'bg-blue-600 text-white' : 'text-blue-600 border-b-2 border-transparent hover:border-blue-600'}`}
                >
                  {section.charAt(0).toUpperCase() + section.slice(1).replace(/([A-Z])/g, ' $1')}
                </div>
              ))}
            </div>
          </div>

          {/* Dynamic Sections */}
          <div className="mt-[20px] h-[calc(100vh-90px)] overflow-y-auto px-4"> 
            {/* Added space between sections */}
            {/* User Detail Form */}
            {activeSection === 'form' && (
              
                <AddSettingForm />
            )}

            {/* Agreement Section */}
            {activeSection === 'agreement' && (
              <AgreementForm />
            )}

            {/* Team Section */}
            {activeSection === 'team' && (
              <TeamMemberForm />
            )}

            {/* Tax Info Section */}
            {activeSection === 'taxInfo' && (
              <TaxInfoForm />
            )}

            {/* API Key Section */}
            {activeSection === 'apiKey' && (
              <ApiKeyForm />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
